import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { NavComponent } from './components/nav/nav.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProgramCardComponent } from './components/program-card/program-card.component';
import { ProgramGraphComponent } from './components/program-graph/program-graph.component';
import { SemiDonutComponent } from './components/semi-donut/semi-donut.component';
import { ProgramDetailComponent } from './components/program-detail/program-detail.component';
import { SubnavComponent } from './components/subnav/subnav.component';
import { TitleHeaderComponent } from './components/title-header/title-header.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { TreeListComponent } from './components/tree-list/tree-list.component';
import { LogInComponent } from './components/log-in/log-in.component';
import { CalculationChamberInvestigationsComponent } from './components/calculation-chamber-investigations/calculation-chamber-investigations.component';

import { ProgramService } from './services/program.service';
import { BegrotingService } from './services/begroting.service';
import { MotiesService } from './services/moties.service';
import { LinksService } from './services/links.service';
import { LinkTypePipe } from './pipes/link-type.pipe';
import { ModalComponent } from './components/modal/modal.component';
import { FinanceModalComponent } from './components/finance-modal/finance-modal.component';
import { TargetComponent } from './components/target/target.component';
import { ProgramContainerComponent } from './components/program-container/program-container.component';
import { CalculationChamberDetailComponent } from './components/calculation-chamber-detail/calculation-chamber-detail.component';
import { ListModalComponent } from './components/list-modal/list-modal.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';

import { NavBarService } from './services/nav-bar.service';
import { VersionService } from './services/version.service';
import { AuthService } from './services/auth.service';
import { TargetService } from './services/target.service';
import { PrestatieService } from './services/prestatie.service';
import { BudgetChangesService } from './services/budget-changes.service';
import { BudgetChangesModalComponent } from './components/budget-changes-modal/budget-changes-modal.component';
import { StudiesService } from './services/studies.service';
import { MotionsComponent } from './components/motions/motions.component';
import { SmileyReplacePipe } from './pipes/smileyReplace.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { ProgramCardSmileyComponent } from './components/program-card-smiley/program-card-smiley.component';
import { GeneralBudgetChangesComponent } from './components/general-budget-changes/general-budget-changes.component';
import { AccessabilityComponent } from './components/accessability/accessability.component';

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    DashboardComponent,
    ProgramCardComponent,
    ProgramGraphComponent,
    ProgramCardSmileyComponent,
    SemiDonutComponent,
    ProgramDetailComponent,
    SubnavComponent,
    TitleHeaderComponent,
    SidenavComponent,
    LinkTypePipe,
    ModalComponent,
    FinanceModalComponent,
    TreeListComponent,
    TargetComponent,
    ProgramContainerComponent,
    CalculationChamberInvestigationsComponent,
    CalculationChamberDetailComponent,
    ListModalComponent,
    TooltipComponent,
    BudgetChangesModalComponent,
    MotionsComponent,
    LogInComponent,
    SmileyReplacePipe,
    FilterPipe,
    GeneralBudgetChangesComponent,
    AccessabilityComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    JsonpModule,
    AppRoutingModule,
  ],
  providers: [
    LinksService,
    ProgramService,
    MotiesService,
    BegrotingService,
    NavBarService,
    TargetService,
    PrestatieService,
    BudgetChangesService,
    StudiesService,
    VersionService,
    AuthService,
    {
      provide: LOCALE_ID,
      useValue: 'nl-NL',
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts